import { render, staticRenderFns } from "./WarehouseItemCreateView.vue?vue&type=template&id=72610675"
import script from "./WarehouseItemCreateView.vue?vue&type=script&lang=js"
export * from "./WarehouseItemCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports